import { createApp } from 'vue'
import App from './App.vue'
import router from './router'

// Bootstrap CSS és JS
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/dist/js/bootstrap.bundle.min.js'

// FontAwesome
import '@fortawesome/fontawesome-free/css/all.min.css'

// SweetAlert2
import Swal from 'sweetalert2'

const app = createApp(App)

// SweetAlert2 globális elérhetővé tétele
app.config.globalProperties.$swal = Swal

// Automatikus tracking eltávolítva - csak manuális lesz

app.use(router)
app.mount('#app')